<template>
  <div class="card">
    <div v-if="renderedIcon !== null" class="card__icon">
      <img :src="icon" />
    </div>
    <div class="card__app-name">App Name</div>
    <div class="card__timestamp">
      {{ $t('PushNotification_Text_Now').toLowerCase() }}
    </div>
    <div class="card__title">
      <span>{{ renderedTitle }}</span>
    </div>
    <div class="card__text" style="white-space: pre-wrap">
      <span>{{ renderedMessage }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PushPreviewWebMacSafari',
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    },
    icon: {
      type: String
    }
  },
  computed: {
    renderedTitle() {
      if (this.title === '' || this.title === null) {
        return this.$t('PushNotification_Text_NotificationPreview')
      } else {
        return this.title
      }
    },
    renderedMessage() {
      if (this.message === '' || this.message === null) {
        return this.$t('PushNotification_Text_NotificationPreviewMessage')
      } else {
        return this.message
      }
    },
    renderedIcon() {
      if (this.icon === '' || this.icon === null) {
        return null
      } else {
        return this.icon
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  position: relative;
  width: 344px;
  height: 110px;
  background: rgba(245, 245, 245, 0.6);
  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(33.2019px);
  border-radius: 10px;

  &__icon {
    position: absolute;
    width: 18px;
    height: 18px;
    left: 9px;
    top: 9px;
    border-radius: 4px;

    & > img {
      width: 18px;
      min-width: 18px;
      max-width: 18px;
      min-height: 18px;
      max-height: 18px;
      height: 18px;
      background-color: rgb(254, 254, 254);
      border-radius: 4px;
    }
  }

  &__app-name {
    position: absolute;
    height: 18px;
    left: 32px;
    right: 82px;
    top: 9px;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: -0.006em;
    text-transform: uppercase;
    color: #797979;
  }

  &__timestamp {
    position: absolute;
    width: 66px;
    height: 16px;
    right: 12px;
    top: 10px;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-align: right;
    color: #797979;
    justify-content: flex-end;
  }

  &__title {
    position: absolute;
    height: 23px;
    left: 11px;
    right: 46px;
    top: 28px;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #232526;

    & > span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__text {
    position: absolute;
    left: 11px;
    right: 11px;
    top: 50px;
    bottom: 12px;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.2px;
    color: #232526;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/push/PushPreviewWebMacSafari.vue